export type HTMLRcmImageElementExtended = HTMLRcmImageElement & {
  imageElementHeight: number;
};

export enum Ratio {
  HD = '16:9',
  WIDE = '2.56:1',
  ORIGINAL = 'original',
  SQUARE = '1:1',
}

export const ratioKeys = Object.keys(Ratio);
export const ratioValues = ratioKeys.map((ratio) => Ratio[ratio]);

export enum Position {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}

export const positionKeys = Object.keys(Position);
export const positionValues = positionKeys.map((position) => Position[position]);

export interface RcmImageProp {
  src: string;
  caption?: string;
  copyright?: string;
  alt?: string;
  title?: string;
}
